// Switcher metadata for the Omni Command shell (EDNA-2005). Extracted from
// federation-entry.ts so the shell can build its icon rail from `meta` without
// pulling the whole CRM bundle into its initial chunk — federation-entry
// re-exports this, so the App/searchProvider/contextCardProvider/meta contract
// is unchanged.
import type { OmniRemoteMeta } from '@omni/objects'

// `contextCardSupport` per Correction 3 — declares which ref kinds this remote
// can answer peek requests for. The shell dispatches peek-* events only to
// remotes whose meta lists the target kind.
export const meta: OmniRemoteMeta = {
  id: 'crm',
  label: 'CRM',
  icon: 'Users',
  basePath: '/crm',
  contextCardSupport: ['customer', 'contact'] as const,
}
